import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useUploadConfirmationImageMutation = () =>
  useTypedMutation<FormData, string>({
    mutationFn: async payload => (await ApiInstance.post("/dashboard/upload_confirmation_image", payload, ENV.kioskBaseURL)).data.url,
    onSuccess: () => null
  });
